import { connect } from 'react-redux';
import PortFolioRow from './PortFolioRow';
import { sortPortfoliosRequest, updatePortfolioFlag } from '../../../../../store/actions/portfolio.actions';

const mapDispatchToProps = { sortPortfoliosRequest, updateFlag: updatePortfolioFlag };

const mapStateToProps = (state) => { 
    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(PortFolioRow);